import { MuiThemeProvider } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/styles';
import cn from 'classnames';
import MaterialTable from 'material-table';
import * as React from 'react';
import { useLayoutEffect, useRef, useState } from 'react';
import { compose } from 'recompose';
import { getMuiTheme } from '../StaticDatatable/materialTableTheme';
import { MATERIAL_TABLE_TRANSLATIONS } from '../StaticDatatable/materialTableTranslations';
import { withBaseProps } from '../Utils/Component';
const styles = () => createStyles({
    tableContainer: {
        height: '100%',
    },
});
const PaginatedAsyncDatatable = (props) => {
    const { t, classes, fetchMore, dataSelector, tableTitle, options, theme, columns, data, compactTable, actions, onError, pageSize, setPageSize, components, queryParams = {}, className: classNameProp, } = props;
    const mounted = useRef(true);
    useLayoutEffect(() => () => {
        mounted.current = false;
    }, []);
    const defaultOptions = {
        draggable: false,
        headerStyle: {
            backgroundColor: tableTitle ? theme.components.table.th.background : theme.color.brand.main,
            color: tableTitle ? theme.components.table.th.color : theme.color.font.light,
            whiteSpace: 'nowrap',
        },
    };
    const [currentPage, setCurrentPage] = useState(0);
    const [currentOrder, setCurrentOrder] = useState({ sort: '', direction: '' });
    const [firstPageResult, setFirstPageResult] = useState(data);
    return (React.createElement("div", { className: cn(classes.tableContainer, classNameProp) },
        React.createElement(MuiThemeProvider, { theme: getMuiTheme(theme, compactTable, !!tableTitle) },
            React.createElement(MaterialTable, { onRowClick: (e) => {
                    return e;
                }, localization: MATERIAL_TABLE_TRANSLATIONS(t), title: tableTitle, options: { ...options, ...defaultOptions }, onChangeRowsPerPage: setPageSize, onOrderChange: (orderByIndex, orderDirection) => {
                    if (mounted.current) {
                        setCurrentOrder({
                            sort: (columns[orderByIndex] && columns[orderByIndex].field) || '',
                            direction: orderDirection.toUpperCase(),
                        });
                    }
                }, columns: columns, actions: actions, data: async (query) => {
                    const firstPageData = dataSelector(firstPageResult);
                    const orderChanged = query.orderBy
                        ? query.orderBy.field !== currentOrder.sort || query.orderDirection !== currentOrder.direction
                        : false;
                    if (query.page === currentPage && query.pageSize === pageSize && query.page === 0 && !orderChanged) {
                        return {
                            data: firstPageData ? firstPageData.edges.map((edge) => Object.assign({}, edge.node)) : [],
                            page: currentPage,
                            totalCount: (firstPageData === null || firstPageData === void 0 ? void 0 : firstPageData.count) || 0,
                        };
                    }
                    const variables = {
                        first: query.pageSize,
                        searchFilter: queryParams.searchFilter,
                    };
                    if (query.page !== 0) {
                        if (query.page > currentPage) {
                            variables.first = query.pageSize;
                            variables.after = firstPageData.pageInfo.endCursor;
                        }
                        else {
                            variables.last = query.pageSize;
                            variables.before = firstPageData.pageInfo.startCursor;
                            variables.first = undefined;
                        }
                    }
                    else if (orderChanged) {
                        variables.after = undefined;
                    }
                    if (query.orderBy) {
                        variables.orderBy = [{ sort: query.orderBy.field, direction: query.orderDirection.toUpperCase() }];
                    }
                    try {
                        const queryResult = await fetchMore({
                            variables,
                        });
                        if (mounted.current) {
                            setCurrentPage(query.page);
                            if (!firstPageResult) {
                                setFirstPageResult(queryResult.data);
                            }
                        }
                        const data = dataSelector(queryResult.data).edges.map((edge) => Object.assign({}, edge.node));
                        const totalCount = dataSelector(queryResult.data).count;
                        console.log('data: ', data);
                        return {
                            data,
                            page: query.page,
                            totalCount,
                        };
                    }
                    catch (err) {
                        if (onError) {
                            onError();
                        }
                        const data = firstPageData ? firstPageData.edges.map((edge) => Object.assign({}, edge.node)) : [];
                        const totalCount = firstPageData ? firstPageData.count : 0;
                        return {
                            data,
                            page: currentPage,
                            totalCount,
                        };
                    }
                }, components: components }))));
};
export default compose(withBaseProps({ styles }))(PaginatedAsyncDatatable);
//# sourceMappingURL=PaginatedAsyncDatatable.js.map